import React from "react";
import { Layout, Space } from "antd";
import "../index.css";

const InventoryLayOutCommon = ({ children }) => {
  return (
    <Layout>
      <Layout style={{ height: "100%" }}>
        <Layout>
          <Space
            direction="vertical"
          >
            {children}
          </Space>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default InventoryLayOutCommon;
